// import React from 'react';
// import newsrecords from './news.json'
// import styles from './newsBlock.module.scss'
// import Image from 'next/image';

// const NewsBlock = () => {
//     return (
//         <div>
//              <div className='row  pt-5'>
//           {
//             newsrecords.reverse().map(newsdata => {
//               return <div key={newsdata.newsdata} className="col-12 col-md-4 text-center ">
//                 <div className="row py-2 mx-1 my-3 " style={{background: '#fff', color: '#000'}}>

//                   <div className={`${styles.TitleDesc}  `} >
//                     <Image className='img-fluid ' src={newsdata.image} width={520} height={250} alt={newsdata.alt} />
                  
//                     <h3 className={`${styles.h3} pt-4`} dangerouslySetInnerHTML={{ __html: newsdata.title }}></h3>
//                   </div>

//                   <div className={`${styles.NewsDesc}  `}>
//                     <p dangerouslySetInnerHTML={{ __html: newsdata.desc }}></p>
//                   </div>

//                   <div className={`  `}>
//                     <a href={newsdata.url}>
//                       <button className="button mx-auto ">READ MORE</button>
//                     </a>
//                   </div>

//                 </div>
//               </div>



//             })
//           }
//         </div>
//         </div>
//     );
// };

// export default NewsBlock;

'use client';

import React, { useState } from 'react';
import newsrecords from './news.json';
import styles from './newsBlock.module.scss';
import Image from 'next/image';

const NewsBlock = () => {
  // State to control the number of news items displayed
  const [visibleNews, setVisibleNews] = useState(3);

  // Function to load more news items
  const loadMoreNews = () => {
    setVisibleNews((prev) => prev + 3); // Increase the count by 3 each time
  };

  // Reverse the news records before slicing to display them in the correct order
  const reversedNews = [...newsrecords].reverse();

  return (
    <div>
      <div className="row py-5">
        {reversedNews
          .slice(0, visibleNews) // Display only the visible news items
          .map((newsdata, index) => (
            <div key={index} className="col-12 col-md-4 text-center">
              <div
                className="row py-2 mx-1 my-3 pb-4"
                style={{ background: '#632838', color: '#fff' }}
              >
                <div className={`${styles.TitleDesc}`}>
                  <Image
                    className="img-fluid"
                    src={newsdata.image}
                    width={520}
                    height={250}
                    alt={newsdata.alt}
                  />
                  <h3
                    className={`${styles.h3} pt-4`}
                    dangerouslySetInnerHTML={{ __html: newsdata.title }}
                  ></h3>
                </div>

                <div className={`${styles.NewsDesc}`}>
                  <p dangerouslySetInnerHTML={{ __html: newsdata.desc }}></p>
                </div>

                <div>
                  <a href={newsdata.url}>
                    <button className={`${styles.button} mx-auto mb-2`}>READ MORE</button>
                  </a>
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Load More button */}
      {visibleNews < reversedNews.length && ( // Show the button only if there are more items to load
        <div className="text-center py-5">
          <button onClick={loadMoreNews} className={styles.loadMoreBtn}>
          LOAD MORE POSTS
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsBlock;
